import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MoveFolderIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 13L12 13L10 13M14 13L12 11M14 13L12 15" stroke={fillColor || 'white'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6C5.67157 6 5 6.67157 5 7.5V16.5C5 17.3284 5.67157 18 6.5 18H17.5C18.3284 18 19 17.3284 19 16.5V9.5C19 8.67157 18.3284 8 17.5 8H12.654C12.2567 8 11.8971 7.76481 11.7379 7.40082L11.3871 6.59918C11.2279 6.23519 10.8683 6 10.471 6H6.5ZM15.4243 13.4243C15.5368 13.3117 15.6 13.1591 15.6 13C15.6 12.8409 15.5368 12.6883 15.4243 12.5757L12.4243 9.57574L11.5757 10.4243L13.5515 12.4L9 12.4L9 13.6L13.5515 13.6L11.5757 15.5757L12.4243 16.4243L15.4243 13.4243Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { MoveFolderIcon };
